import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound = ({ error }) => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" flexDirection="column" marginX={50} textAlign="center" whiteSpace={10}>
            {/* <img src={notFoundImage} alt="Page Not Found" style={{ width: '50%', maxWidth: '300px', marginBottom: '20px' }} /> */}
            {error && (
                <>
                    <Typography variant="h1" color="red" gutterBottom>
                        {error.data.error}
                    </Typography>
                    <Typography variant="h3" gutterBottom>
                       
                        {error.status}
                       
                    </Typography>

                </>
            )}

            <Typography variant="h5" gutterBottom>
                Oops! Page Not Found
            </Typography>
            <Typography variant="body1" gutterBottom>
                The page you are looking for might have been removed, had its name changed,
                or is temporarily unavailable.
            </Typography>

            <Button component={Link} to="/" variant="contained" color="light" size="large">
                Go to Home
            </Button>
        </Box>
    );
};

export default NotFound;
